import { OrderFields } from "../../../constants";
import type { TAddressRequestParams, TUpdateAddressForm } from "../types";

const mapUpdateAddressToRequestParams = (address: TUpdateAddressForm): Partial<TAddressRequestParams> => {
  const {
    [OrderFields.RECEIVER_NAME]: contactName,
    [OrderFields.RECEIVER_EMAIL]: contactEmail,
    [OrderFields.RECEIVER_PHONE_NUMBER]: contactPhone,
    [OrderFields.RECEIVER_LOCKER]: lockerId,
    [OrderFields.DESTINATION_COUNTRY]: countryCode,
    [OrderFields.RECEIVER_STREET]: street,
    [OrderFields.RECEIVER_HOUSE_NO]: streetNumber,
    [OrderFields.RECEIVER_FLAT_NO]: flatNo,
    [OrderFields.RECEIVER_CITY]: city,
    [OrderFields.RECEIVER_ZIP_CODE]: zip,
  } = address;

  const hasLockerValue = !!lockerId;
  const hasAddressValues = !!countryCode && !!street && !!city && !!zip;

  return {
    contactName,
    contactEmail,
    contactPhone,
    ...(hasLockerValue && { lockerId }),
    ...(hasAddressValues && { countryCode, street, streetNumber, flatNo, city, zip }),
  };
};
export default mapUpdateAddressToRequestParams;
